module.exports = "pegasus/assets/theme4/small/3.jpg";